import { Navigate } from 'react-router-dom';
import { getAffiliatePermissions } from 'src/configs/affiliatePermissions';

const AdminGuard = ({ children }) => {
  const { adm } = JSON.parse(localStorage.getItem('user') || '{}');
  const { isAffiliate } = getAffiliatePermissions();

  if (!adm || isAffiliate) {
    return <Navigate to="/extended-sidebar/menu/home" replace />;
  }

  return children;
};

export default AdminGuard;
